import React from "react";

const CookieButton = ({text, icon = "", className = null, onClick}) => {

    const _icon = ( icon.length > 0 ? <i className={icon}></i> : "" );

    return(
        <button type="button" className={`cookie-button${( className ? " " + className : "")}`} onClick={ onClick }>{_icon}{text}</button>
    )
}

export default CookieButton;